import { Unstable_Grid2 as Grid } from '@mui/material';

import { TextField } from '@occc-app/design-system';

export const SegmentFormContent = () => {
  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={6}>
        <TextField name='name' label='Name' margin='normal' required fullWidth />
      </Grid>
      <Grid xs={12} sm={6}>
        <TextField
          name='description'
          label='Description'
          multiline
          margin='normal'
          required
          fullWidth
        />
      </Grid>
    </Grid>
  );
};
